import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface IVariables { organizationId: string; activityId: number; }

const useDeleteCRMActivity = (
    options: Omit<UseMutationOptions<void, AxiosError, IVariables>, 'mutationFn'> = {},
) => useMutation({
    mutationFn: async (variables: IVariables) => {
        const { organizationId, activityId } = variables;
        const res = await axiosInstance.delete<void>(
            API_ENDPOINTS.CRM.ACTIVITY(organizationId, activityId),
        );
        return res.data;
    },
    ...options,
});

export default useDeleteCRMActivity;
